const HEIGHT_FACTORS = {
  mm: 1,
  cm: 10,
  m: 1000
}

export default class {
  constructor (configurator) {
    this.configurator = configurator
  }

  process () {
    this.configurator.fencePriceApplied = false
    this.configurator.fencePriceTotal = 0

    const priceList = this.configurator.fencePriceList

    if (!priceList || priceList.isEmpty()) {
      return this
    }

    const step = this.configurator.steps.find(s => s.type === 'dimension')

    if (!step || !step.price) {
      return this
    }

    const total = this.getSegmentsTotal(priceList, step)

    step.price.self = total
    step.price.total = total

    if (total > 0) {
      this.configurator.fencePriceApplied = true
      this.configurator.fencePriceTotal = total
    }

    return this
  }

  getSegmentsTotal (priceList, step) {
    const option = this.getSelectedModelOption()
    const meters = this.getRunningMeters()

    if (!option || meters <= 0) {
      return 0
    }

    const pricePerMeter = priceList.getPricePerMeter(option, this.getHeightInMillimeters(step))

    return pricePerMeter === null ? 0 : meters * pricePerMeter
  }

  getSelectedModelOption () {
    const step = this.configurator.steps.find(s => s.model_step) ||
      this.configurator.steps.find(s => s.name === 'Muster')

    if (!step || !step.options) {
      return null
    }

    return step.options.find(option => option.selected) || null
  }

  getRunningMeters () {
    if (this.configurator.lfm > 0) {
      return this.configurator.lfm
    }

    const step = this.configurator.steps.find(s => s.type === 'quantity')

    return step && step.aw > 0 ? step.aw : 0
  }

  getHeightInMillimeters (step) {
    const height = step.height || {}
    const value = Number.parseFloat(height.value) || 0
    const factor = HEIGHT_FACTORS[height.unit]

    if (factor) {
      return value * factor
    }

    return value < 400 ? value * 10 : value
  }
}
